import classNames from 'classnames';
import React from 'react';

interface ITab {
  name: string;
}

interface IProps {
  selected: number;
  tabs: ITab[];
  onChange: (index: number) => void;
}

export const TabBar: React.FC<IProps> = (props) => {
  const {selected, tabs} = props;

  if (selected >= tabs.length) {
    throw new Error('Selected tab index is out of range.');
  }

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    props.onChange?.(tabs.findIndex((tab) => tab.name === event.target.value));
  };

  return (
    <div className="mt-4 mb-4">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          defaultValue={tabs[selected].name}
          onChange={onChange}>
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="-mb-px flex space-x-4" aria-label="Tabs">
          {tabs.map((tab, i) => (
            <div
              onClick={() => props.onChange(i)}
              key={tab.name}
              className={classNames(
                i === selected
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-500 hover:text-gray-700',
                'rounded-md px-3 py-2 text-sm font-medium cursor-pointer',
              )}
              aria-current={i === selected ? 'page' : undefined}>
              {tab.name}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};
